import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';

import { BookApiEntity } from '@app/user-content/user-input/book-forms/repository/book.entity.model';
import { BookForm, ViewModel } from '../book.model';
import { PathwayStep } from '@dg/pathways-rsm';
import { parseImageDataForBE } from '@app/user-content/user-input-v2/utils/image-data-utils';
import { ImageUrlService } from '@app/user-content/user-input/services/image-url.service';

@Injectable({ providedIn: 'root' })
export class BookMapper {
  constructor(
    private datePipe: DatePipe,
    private imageUrlService: ImageUrlService
  ) {}

  public toApiParameters(source: BookForm): BookApiEntity {
    if (!source.book) {
      return;
    }

    const bookEntity: BookApiEntity = {
      userBookId: source.userInputId,
      inputType: source.inputType,
      bookId: source.book.bookId,
      title: source.book.title,
      subtitle: source.book.subtitle,
      externalId: source.book.externalId,
      summary: source.book.description,
      author: source.book.author,
      provider: source.book.providerCode,
      isbn13: source.book.isbn,
      imageUrl: source.book.imageUrl,
      externalData: source.book.externalData,
      format: source.book.format,
      language: source.book.language,
      owner: source.book.owner,
      durationUnitType: source.book.durationUnitType,
      durationUnits: source.completionInfo
        ? source.completionInfo.length
        : source.length,
      dateRead: this.datePipe.transform(
        source.completionInfo.dateRead,
        'yyyy-MM-dd'
      ),
      authored: source.isUserAuthored,
      comment: source.comment,
      tags: source.tags,
      orgContentMetadata: {
        hideFromCatalog: true, // books are always hidden from the catalog
      },
      organizationId: source.organizationId,
    };

    return bookEntity;
  }

  /**
   * Only called on detail edit. Update top-level step properties.
   *
   * @param source
   * @param step
   */
  public toStep(source: BookForm, step: PathwayStep): ViewModel {
    return {
      ...source,
      ...step,
      description: source.book.description,
      title: source.book.title,
      ...parseImageDataForBE(source.book, this.imageUrlService),
    } as unknown as ViewModel;
  }
}
